// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sticky-filters {\n  display: block;\n  width: 100%;\n  position: sticky;\n  top: 0;\n  left: 15px;\n  z-index: 100;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n.table-scroll-wrapper {\n  width: 100%;\n  max-height: 700px;\n  overflow-y: auto;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n}\n.table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background-color: white;\n}\n", ""]);
// Exports
module.exports = exports;
